/**
 * Returns a promise which resolves when an image has loaded.
 */
export function loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        img.onload = () => resolve(img);
        img.onerror = error => reject(error);
        img.src = src;
    });
}

/**
 * Returns a promise which resolves when a script has loaded.
 */
export function loadScript(src: string, async: boolean = true): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = async;
        script.onload = () => resolve(script);
        script.onerror = error => reject(error);
        script.src = src;

        document.body.appendChild(script);
    });
}
